<script>
    import Layout from "../../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Forms from "../../../../mixins/Forms";
    import axios from 'axios';

    /**
     * Ticket email template create component
     */
    export default {
        page: {
            title: "Create New Ticket WhatsApp Template",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader},
        mixins: [Forms],
        data() {
            return {
                title: "Create New Ticket Whatsapp Template",
                items: [
                    {
                        text: "Settings",
                        href: "#"
                    },
                    {
                        text: "Create Ticket Whatsapp Template",
                        active: true
                    }
                ],
                form: {
                    name: '',
                    body: '',
                    twilio_template_sid: ''
                },
                serverErrors: [],
                isSaving: false
            };
        },
        methods: {
            attemptSave() {
                this.save();
            },

            save() {
                let vm = this;

                vm.isSaving = true;
                axios.post(API_BASE + '/ticket-whatsapp-templates', {
                    name: vm.form.name,
                    body: vm.form.body,
                    twilio_template_sid: vm.form.twilio_template_sid
                }).then(r => {
                    vm.isSaving = false;
                    this.$notify.success({
                        title: 'Success!',
                        message: 'Template created successfully'
                    });
                    vm.$router.push('/settings/ticket-whatsapp-templates/');
                }).catch(e => {
                    console.log(e);
                    vm.isSaving = false;
                    vm.setErrors(e);
                });
            }
        }
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items"/>
        <errors :error-list="serverErrors"></errors>
        <loading-screen :is-loading="isSaving"></loading-screen>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <form>
                            <div class="form-group row mb-4">
                                <label for="subject" class="col-form-label col-lg-2">Name</label>
                                <div class="col-lg-10">
                                    <input
                                            id="name"
                                            name="name"
                                            type="text"
                                            class="form-control"
                                            v-model="form.name"
                                            autofocus
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="template" class="col-form-label col-lg-2">Template</label>
                                <div class="col-lg-10">
                                    <textarea
                                        id="body"
                                        name="body"
                                        class="form-control"
                                        rows="5"
                                        v-model="form.body"
                                    ></textarea>
                                </div>
                            </div>
                            <div class="form-group row mb-4">
                                <label for="twilio_template_sid" class="col-form-label col-lg-2">Twilio Template SID</label>
                                <div class="col-lg-10">
                                    <input
                                        id="twilio_template_sid"
                                        name="twilio_template_sid"
                                        type="text"
                                        class="form-control"
                                        v-model="form.twilio_template_sid"
                                        placeholder="Optional"
                                    />
                                </div>
                            </div>
                        </form>
                        <div class="row justify-content-end">
                            <div class="col-lg-10">
                                <button type="submit" class="btn btn-itg-dark" @click.prevent="attemptSave">Create
                                    Ticket WhatsApp Template
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>

<style scoped>
</style>
